// Reporting
export const ERROR_REPORT_START = 'ERROR_REPORT_START';
export const ERROR_REPORT_SUCCESS = 'ERROR_REPORT_SUCCESS';
export const ERROR_REPORT_FAILURE = 'ERROR_REPORT_FAILURE';

// Error Status
export const SET_ERROR_STATE = 'SET_ERROR_STATE';
